<script setup lang="ts">
const { useCoreBlog, blogUrlWpApi } = useLinks();
</script>

<template>
  <BaseBlogCore v-if="useCoreBlog" />

  <BaseBlogWP v-else-if="blogUrlWpApi" />

  <div
    v-else
    class="pb-2"
  >
    <div class="alert alert-warning">
      <span>{{ $t('no_posts_found') }}</span>
    </div>
  </div>
</template>
